// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JOIN","newExpiryDate":"styles_newExpiryDate__3mNCQ","footer":"styles_footer__Ep5x3"};